import React from "react";
import styled from "@emotion/styled";
import { bomappURL } from "discription";

const Footer = () => (
  <FooterWrap>
    <ul className="footerLink">
      <li>
        <a
          href={bomappURL.termsOfService}
          target="_blank"
          rel="noopener noreferrer"
        >
          서비스 이용약관
        </a>
      </li>
      <li>
        <a
          href={bomappURL.pravicyPolicy}
          target="_blank"
          rel="noopener noreferrer"
        >
          개인정보 처리방침
        </a>
      </li>
    </ul>
    <p>
      보맵파트너(주) 대표 : 최홍석 <br />
      사업자 등록번호 : 674-87-01039
      <span className="textDivider">|</span>
      통신판매업신고 : 2019-서울서초-1841
      <br />
      서울특별시 서초구 강남대로 369, 12층 1639호(서초동)
      <br />
      개인정보보호책임자 : 박성준
      <span className="textDivider">|</span>
      서비스 개발 및 운영 : 보맵(주)
      <br />
    </p>
    <p className="customerCenter">
      고객센터 :{" "}
      <a className="tell" href="tel:1522-9657">
        1522-9657
      </a>
      <br />
      평일 10:00 ~ 18:00 (점심:12:30~13:30, 토, 일, 공휴일 제외)
    </p>
  </FooterWrap>
);

const FooterWrap = styled.footer`
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: ${props => props.theme.footer.colorBg};
  color: ${props => props.theme.footer.colorFont};
  font-size: ${props => props.theme.footer.sizeFont};
  text-align: center;
  line-height: 1.67;

  .footerLink {
    margin-bottom: 20px;

    > li {
      display: inline-block;
      margin-top: 5px;

      &:before {
        content: "";
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
        width: 1px;
        height: 12px;
        background-color: ${props => props.theme.colors.footerDivider};
        vertical-align: middle;
      }

      &:first-of-type:before {
        content: none;
      }
    }
  }

  .customerCenter {
    display: block;
    margin-top: 20px;
  }

  .tell {
    color: ${props => props.theme.footer.colorTell};
  }

  .textDivider {
    margin: 0 8px;
  }
`;

export default Footer;
